type CsvCell = string | number | null | undefined;

const escapeCsvCell = (value: CsvCell): string => {
  const str = value === null || value === undefined ? "" : String(value);
  if (/[";\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const buildCsv = (headers: string[], rows: CsvCell[][]): string => {
  const BOM = "﻿";
  const lines = [headers, ...rows].map((row) =>
    row.map(escapeCsvCell).join(";")
  );
  return `${BOM}${lines.join("\r\n")}`;
};
